/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  useDifferentAddress: {
    id: 'AuthenticatedAddressForm.useDifferentAddress',
    defaultMessage: 'Use a Different Address'
  },
  legend: {
    id: 'Address.saved.legend',
    defaultMessage: `Enter {type, select, 
                              DELIVERY {Delivery} 
                              BILLING {Billing} 
                              other { }
                           } Address`
  },
  chooseSaved: {
    id: 'Address.saved.chooseSaved',
    defaultMessage: `Choose {type, select, 
                              DELIVERY {Delivery} 
                              BILLING {Billing} 
                              other { }
                           } Address`
  },
  chooseAddress: {
    id: 'Address.saved.chooseAddress',
    defaultMessage: 'Select an Address'
  },
  fleetAddressMessage: {
    id: 'Address.saved.fleetAddressMessage',
    defaultMessage:
      'Please fill in First Name, Last Name, and Phone Number for fleet addresses.'
  }
});
